<div class="content">
  <a href="https://www.covercy.com"><img class="logo" src="assets/images/logo/Covercy_logo.png" alt="covercy-home"/></a>
  <img class="icon" src="assets/images/general/maintenance.png" />
  <h1>WE'LL BE RIGHT BACK!</h1>
  <p>
    Sorry! We're upgrading and fixing the site.
    <br />
    We'll be up and running again soon.
  </p>
  <a class="mail-link" href="mailto:Support@covercy.com">Support Email</a>
</div>
